import React from 'react';
import ConfiguratorOption from '../ConfiguratorOption';
import DimmbareLED from '../../images/6/reactcode/DimmbareLED';
import MitLED from '../../images/6/reactcode/MitLED';
import NichtDimmbareLED from '../../images/6/reactcode/NichtDimmbareLED';

interface ProductLEDProps {
  selected: string;
  onSelect: (colour: string) => void;
}

const ProductLED: React.FC<ProductLEDProps> = ({ selected, onSelect }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 gap-x-3 gap-y-3 w-full">
      <ConfiguratorOption
        key={"1"}
        label="Keine LED"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/Led01.png`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/led1.svg`}
        onClick={() => onSelect("Keine LED")}
        isSelected={selected === "Keine LED"}
        SVGComponent={() => <NichtDimmbareLED />}


      />
      <ConfiguratorOption
        key={"2"}
        label="Nicht dimmbare LED"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/Led02.png`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/led2.svg`}
        onClick={() => onSelect('Nicht dimmbare LED')}
        isSelected={selected === "Nicht dimmbare LED"}
        SVGComponent={() => <MitLED />}


      />
      <ConfiguratorOption
        key={"3"}
        label="Dimmbar"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/Led03.png`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/led3.svg`}
        onClick={() => onSelect('Dimmbar')}
        isSelected={selected === "Dimmbar"}
        SVGComponent={() => <DimmbareLED />}

      />
    </div>
  );
};

export default ProductLED;
